/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ConciergeBellIconConfig = {
  name: 'ConciergeBellIcon',
  height: 512,
  width: 512,
  svgPath: 'M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ConciergeBellIconConfig);